// @ts-nocheck
import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  IconButton,
  ThemeProvider,
  createTheme,
  Popover,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import Grid from "@mui/material/Grid2";
import Link from "@mui/material/Link";
import StepperComponent from "../customs/CustomStepper";
import RightSidebar from "../sidebar/RightSidebar";
import { useLocation, useParams } from "react-router-dom";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../services/AuthContext";
import parse from "html-react-parser";
import { BsChevronRight, BsChevronLeft } from "react-icons/bs";
import { GoImage } from "react-icons/go";
import { useDispatch, useSelector } from "react-redux";
import { fetchPropertyDetails } from "../../redux/slice/propertyDetailsSlice";
import Loading from "../Loading";
import { LiveIcon } from "../Live";
import { addBidToToday, clearMyBidUpdates, removeExcludedId } from "../../redux/slice/mybidSlice";
import CloseIcon from "@mui/icons-material/Close";
import {
  addFavoriteProperty,
  addSelectedId,
  removeSelectedId,
} from "../../redux/slice/favoritePropertySlice";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Helmet } from "react-helmet";
import Bed from "../../assets/bed.svg";
import Bath from "../../assets/bath.svg";
import Sqft from "../../assets/sqft.svg";
import { textColor } from "../../utils/commonstyle";
import { BackButton } from "../commonComponents/BackButton";
import { AppDispatch, RootState } from "@/redux/store";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    error: {
      main: "#d32f2f",
    },
  },
  typography: {
    fontFamily: "Poppins",
  },
});

export default function ProductDetailsPage() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [popover, setPopover] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({ 0: true, 1: false });
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imgLoading, setImgLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewMore, setViewMore] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isExpandedOtherInfo, setIsExpandedOtherInfo] = useState(false);
  const [pdfUrl, setPdfUrl] = useState<string>(""); // To store PDF URL
  const [pdfopen, setPdfOpen] = useState(false);
  const [pdfName, setPDFName] = useState("");

  const [countdown, setCountdown] = useState(0);
  const [statusmessage, setStatusMessage] = useState("");
  const [investorIdCheck, setInvestoprIdCheck] = useState<any>('')
  const dispatch = useDispatch<AppDispatch>();
  const myBidData = useSelector((state: RootState) => state.mybid.myBidData?.data); // Get the current Redux state
  const { loginInvestorId, loginUserDetails } = useSelector((state: RootState) => state.user); // Get the current Redux state

  // for future implementation
  const {
    investorId: { investorId, username },
  } = useAuth();
  // for future implementation

  const handleInvestorId = () => {
    // Check if BusinessAccounts and PurchaseProfile exist and have data
    if (loginUserDetails?.BusinessAccounts && (loginUserDetails?.BusinessAccounts?.length > 0 || loginUserDetails?.PurchaseProfile?.length > 0)) {
      const businessInvestorIds = loginUserDetails?.BusinessAccounts.map((ele: any) => ele.InvestorId);
      // Check if PurchaseProfile exists and has data
      const purchaseProfileInvestorIds = loginUserDetails?.PurchaseProfile?.map((ele: any) => ele.InvestorId) || [];
      // Combine both arrays (BusinessAccounts and PurchaseProfile)
      setInvestoprIdCheck([loginInvestorId, ...businessInvestorIds, ...purchaseProfileInvestorIds]);
    } else {
      // If BusinessAccounts is empty or doesn't exist, set only the loginInvestorId
      setInvestoprIdCheck([loginInvestorId]);
    }
  };

  useEffect(() => {
    handleInvestorId()
  }, [])
  const navigate = useNavigate();
  const param = useParams();

  const location = useLocation();
  const remoteflag = location?.state?.remoteflag || localStorage.getItem('remoteflag');

  useEffect(() => {
    if (location?.state?.remoteflag) {
      localStorage.setItem('remoteflag', location.state.remoteflag);
    }
  }, [location?.state?.remoteflag]);



  const handleImageLoad = () => {
    setImgLoading(false);
  };

  const handleImageError = () => {
    setImgLoading(false);
  };

  const {
    propertyDetails: data,
    loading,
    error,
  } = useSelector((state) => state.propertyDetails);

  const { favoriteProperties } = useSelector(
    (state) => state.favoriteProperties
  );

  const selectedIndex = useSelector(
    (state) => state.favoriteProperties.selectedIds
  );

  const openingDate = moment(data?.cascadeInfo?.currentSaleDate).format(
    "MMMM DD"
  );

  const openingTime = moment(
    data?.cascadeInfo?.currentSaleTime,
    "HH:mm:ss"
  ).format("hh:mm A");

  useEffect(() => {
    if (param.propertyId) {
      setImgLoading(true);
      dispatch(fetchPropertyDetails(param.propertyId)).unwrap();
    } else {
      error("No valid id found");
    }
  }, [param, navigate]);

  const currentSaleDate = data?.cascadeInfo?.currentSaleDate;
  const currentSaleTime = data?.cascadeInfo?.currentSaleTime;

  const currentSaleDateTime = `${currentSaleDate} ${currentSaleTime}`;

  const auctionStartDate = new Date(currentSaleDateTime);

  const countdownInterval = useRef(null); // UseRef to store the interval ID and clear it later

  useEffect(() => {
    const updateCountdowns = () => {
      let newCountdown = {};
      // Parse the auction's opening date using moment.parseZone to handle any time zone info
      const openingDate = moment
        .parseZone(data?.internalDateTimeZone)
        .valueOf(); // Convert to milliseconds

      // Get the current time in milliseconds
      const currentTime = moment().valueOf(); // current time in milliseconds

      // Calculate the countdown for each auction
      newCountdown = openingDate > currentTime ? openingDate - currentTime : 0;
      setCountdown(newCountdown);
      // setLoadingTimer(false);  // Set loading to false once countdowns are updated
    };

    // Update countdown immediately on mount
    updateCountdowns();

    // Set interval to update countdown every second
    const intervalId = setInterval(() => {
      updateCountdowns();
    }, 1000);

    // Clear interval on component unmount
    return () => clearInterval(intervalId);
  }, [data]);

  const formatCountdown = (time) => {
    const days = Math.floor(time / (1000 * 60 * 60 * 24)); // Calculate days
    const hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)); // Calculate hours
    const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60)); // Calculate minutes
    const seconds = Math.floor((time % (1000 * 60)) / 1000); // Calculate seconds

    // Initialize an empty array to store the parts of the countdown
    const countdownParts = [];

    // Add days and hours to the array only if they are non-zero and format as two digits
    if (days > 0) countdownParts.push(`${String(days).padStart(2, "0")}d`);
    // if (hours > 0 || days > 0)

    countdownParts.push(`${String(hours).padStart(2, "0")}h`); // Show hours if days > 0 or hours > 0
    // Always add minutes and seconds to the array, even if they are zero, and format as two digits
    countdownParts.push(`${String(minutes).padStart(2, "0")}m`);
    countdownParts.push(`${String(seconds).padStart(2, "0")}s`);
    console.log(countdownParts)
    // Join the array with spaces and return the formatted string
    return countdownParts.join(" ");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (
      !data?.cascadeInfo?.marketingDescription ||
      data?.cascadeInfo?.marketingDescription.length < 1
    ) {
      setViewMore(true);
    }
  }, [data]);

  const toggleSidebar = async (state, event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsSidebarOpen(state);
  };

  // start -  will require for upcoming feature

  //   // const fetchProxyBid = async () => {
  //   //   try {
  //   //     if(data){
  //   //       const {id} = data;
  //   //       console.log("Investor ID:-",investorId)
  //   //       const response = await getProxyBidId(id,investorId)
  //   //       console.log("Response:-",response.data)
  //   //     }
  //   //   } catch (error) {
  //   //     console.error(error)
  //   //   }}

  // end -  will require for upcoming feature
  const auctionId = data?.internalAuctionId;
  const handlePlaceBid = async (event: React.MouseEvent<HTMLButtonElement>) => {
    if (
      (countdown < 1 || data?.auctionStatusName === "Live" || data?.auctionStatusName === "Pause" || data?.auctionRedoStatus !== 0) && data?.auctionStatusName != "Cancelled"
    ) {
      const bidData =
      {
        address: data?.addressLine1 + " " + data?.addressLine2,
        id: auctionId,
        auctionStatus: data?.auctionStatusName,
        status: false,
        srpSaleDateTime: data?.internalDateTimeZone,
      };
      console.log(bidData, "data")
      const isDuplicate = myBidData?.Today?.some(
        (auction) => auction.id === bidData.id
      );
      dispatch(removeExcludedId(auctionId))
      console.log(isDuplicate, "isduplicate")
      if (isDuplicate) {
        await dispatch(clearMyBidUpdates(bidData.id));
        // Dispatch the action to update the Today array in the local updates state if it's not a duplicate
        await dispatch(addBidToToday(bidData));
      } else {
        await dispatch(addBidToToday(bidData));
      }

      navigate(`/liveauction/${auctionId}`);
    } else if (
      countdown > 1000 * 60 * 60 ||
      data?.auctionStatusName === "Upcoming"
    ) {
      toggleSidebar(true, event);
    }
  };

  const photos = data?.propertyDetails?.photos || [];

  const handleNextPhoto = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % photos.length);
  };

  const handlePrevPhoto = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  function formatToDollar(amount, maxDigit) {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 0, // No decimal places
      maximumFractionDigits: 0,
    }).format(amount);
  }


  const isPlaceBidButtonEnabled = (status) => {
    // If remoteflag is false, disable the Place Bid button
    if (!remoteflag) {
      return false;
    }
    if (countdown > 0 && countdown <= 1000 * 60 * 60 && (status === "PreAuctionClosed" || status === "Upcoming" || status === "Postponed")) {
      return false
    }

    return true;
  };

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return ""; // Handle case when there's no phone number
    // Remove non-numeric characters (optional if you expect only digits)
    const cleaned = phoneNumber.replace(/\D/g, "");

    // Format the number as XXX-XXX-XXXX
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return phoneNumber; // Return unformatted if it doesn't match the expected length
  };

  const handleInfoBoxOpen = (event) => {
    setAnchorEl(event.currentTarget); // Set the button as the anchor element for the popover
    setPopover(true); // Open the popover
  };

  // Handle popover close
  const handleInfoBoxClose = () => {
    setPopover(false); // Close the popover
  };

  const estOpeningBid = parseInt(data?.propertyDetails?.startingBid);

  const handleAddFavoriteProperties = async (propertyId) => {
    const requiredData = {
      investorId,
      propertyId,
      isRemoved: selectedIndex.includes(propertyId), // The toggled value for removal
    };

    try {
      // Dispatch action to add/remove from favorites
      if (selectedIndex.includes(propertyId)) {
        dispatch(removeSelectedId(propertyId));
      } else {
        dispatch(addSelectedId(propertyId));
      }
      await dispatch(addFavoriteProperty(requiredData));
      // Fetch the updated list of favorite properties
      // Optionally, you may want to handle the updated list in your UI here
    } catch (error) {
      console.log(error);
    }
  };
  const handleTranctedText = (text, length) => {
    return text?.length > length ? text?.slice(0, length) + "..." : text;
  };
  // Truncate the text if it's longer than 300 characters
  const truncatedText =
    data?.cascadeInfo?.marketingDescription?.length > 300
      ? data?.cascadeInfo?.marketingDescription?.slice(0, 300) + "..."
      : data?.cascadeInfo?.marketingDescription;
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loading />
      </div>
    );
  }

  const squareFeetDetail = data?.propertyDetails?.basicDetails?.find(
    (item) => item.label === "Square Feet"
  );

  const openPDFModal = (url: string, name: string) => {
    const fileExtension = name.split(".").pop()?.toLowerCase();
    if (!fileExtension) {
      console.error("File extension is missing");
      return;
    }

    // Handle PDF files
    if (fileExtension === "pdf") {
      // Open the URL in a new tab
      const newTab = window.open(url, "_blank");
      if (newTab) {
        newTab.focus(); // Focus the new tab (optional)
      }
    }
    // Handle image files (optional for future use)
    else if (["jpg", "jpeg", "png", "gif"].includes(fileExtension)) {
      const newTab = window.open(url, "_blank");
      if (newTab) {
        newTab.focus(); // Focus the new tab (optional)
      }
    } else {
      console.error("Unsupported file type");
      return;
    }
  };
  // const openPDFModal = (doc: string, name: string) => {
  //   // Split the name and get the extension
  //   const fileExtension = name.split(".").pop()?.toLowerCase();

  //   // Check if fileExtension is valid
  //   if (!fileExtension) {
  //     console.error("File extension is missing");
  //     return;
  //   }

  //   // Handle PDF files
  //   setPdfUrl(doc); // Set the PDF URL state
  //   // Handle unsupported file types
  //   // Open the dialog to display the PDF
  //   setPdfOpen(true);
  //   setPDFName(name); // Set the name of the file (optional)
  // };
  // const totalCountdownMs = (countdown.days * 24 * 60 * 60 + countdown.hours * 60 * 60 + countdown.minutes * 60 + countdown.seconds) * 1000;
  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <title>{`xBid | Property Details`}</title>
        <meta
          name="description"
          content={`${data?.cascadeInfo?.marketingDescription?.slice(0, 155) ||
            `${data?.cascadeInfo?.address} - ${data?.propertyDetails?.bedroomsTotal || ""
            } beds, ${data?.propertyDetails?.bathroomsTotal || ""} baths`
            } Reserve Price: $${formatToDollar(
              data?.cascadeInfo?.reserveValue || 0
              , 2)}`}
        />

        {/* Open Graph tags for social sharing */}
        <meta
          property="og:title"
          content={`${data?.propertyDetails?.basicDetails?.[0]?.value ||
            data?.cascadeInfo?.address ||
            "Property Details"
            } | Remote Bidding`}
        />
        <meta
          property="og:description"
          content={`${data?.cascadeInfo?.marketingDescription?.slice(0, 155) ||
            `${data?.cascadeInfo?.address} - ${data?.propertyDetails?.bedroomsTotal || ""
            } beds, ${data?.propertyDetails?.bathroomsTotal || ""} baths`
            } Reserve Price: $${formatToDollar(
              data?.cascadeInfo?.reserveValue || 0
              , 2)}`}
        />
        <meta property="og:image" content={photos?.[0] || ""} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />

        {/* Additional meta tags */}
        <meta
          name="keywords"
          content={`real estate auction, ${data?.propertyDetails?.basicDetails?.[0]?.value || ""
            }, ${data?.cascadeInfo?.city || ""}, ${data?.cascadeInfo?.state || ""
            }, ${data?.propertyDetails?.bedroomsTotal || ""} bedroom, ${data?.propertyDetails?.bathroomsTotal || ""
            } bathroom`}
        />
        <meta
          name="robots"
          content={
            data?.auctionStatusName === "Live"
              ? "index, follow"
              : "noindex, follow"
          }
        />
        <meta name="author" content="Remote Bidding" />
        <meta name="geo.region" content={`US-${data?.cascadeInfo?.state}`} />
        <meta name="geo.placename" content={data?.cascadeInfo?.city} />
      </Helmet>
      <Dialog
        open={pdfopen}
        onClose={() => setPdfOpen(false)}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg" // Adjust max width of the dialog
        PaperProps={{
          style: {
            width: "80vw", // Use 80% of viewport width
            height: "80vh", // Use 80% of viewport height
            maxHeight: "90vh", // Limit the height to 90% of the viewport
          },
        }}
      >
        <DialogTitle
          id="responsive-dialog-title"
          sx={{
            fontSize: "13px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {pdfName}
          <Typography sx={{ textAlign: "right" }}>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setPdfOpen(false)}
              aria-label="close"
              sx={{ padding: 0, fontSize: "12px" }}
            >
              <CloseIcon />
            </IconButton>
          </Typography>
        </DialogTitle>
        <DialogContent>
          <object
            data={pdfUrl}
            type="application/pdf"
            width="100%"
            height="100%"
          >
            {/* <p>
              Your browser does not support PDFs.{" "}
              <a href={pdfUrl}>
                Download the PDF
              </a>
              .
            </p> */}
          </object>
        </DialogContent>
      </Dialog>
      <div className="flex items-center mb-2">
        <BackButton />
      </div>
      <Paper sx={{ p: 2, width: "99%" }}>
        <Grid
          container
          // spacing={2}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
        >
          {/* Left Column - Property Info */}
          <Grid item xs={"auto"} md={8}>
            <Typography variant="body2" color="#3B3B3B">

              <span className="font-semibold text-lg">
                $

                {data?.propertyDetails?.startingBid === null || data?.propertyDetails?.startingBid === 0 || data?.propertyDetails?.startingBid === "0" || data?.propertyDetails?.startingBid === 0.00
                  ? (data?.cascadeInfo?.reserveValue > 0 ? formatToDollar(data?.cascadeInfo?.reserveValue, 2) : 0)

                  : formatToDollar(
                    data?.propertyDetails?.startingBid, 2
                  )}
                <span className="text-[16px] font-normal">{" "}Est. Opening Bid </span>
              </span>
              {/* <Box
                component="span"
                sx={{
                  ml: 1,
                  bgcolor: "green",
                  color: "white",
                  px: 0.5,
                  fontSize: "12px",
                  borderRadius: "4px",
                }}
              >
                NEW
              </Box> */}
            </Typography>

            <Typography
              variant="body2"
              color="#3B3B3B"
              sx={{ marginTop: { xs: 1, sm: 2 } }}
            >
              <span className="font-medium text-base">
                {data?.cascadeInfo?.address}{" "}
                <span className="font-normal text-base">
                  {data?.cascadeInfo?.city}, {data?.cascadeInfo?.state}{" "}
                  {data?.cascadeInfo?.zip}
                </span>
              </span>
            </Typography>
          </Grid>

          {/* Right Column - Property Features and Save Button */}
          <Grid
            item
            xs={"auto"}
            md={4}
            textAlign="right"
            sx={{ mx: { sm: 3 } }}
          >
            {
              <div className="hidden sm:flex items-center space-x-2 sm:space-x-3 mt-2 justify-end">
                <div className="flex items-center space-x-1">
                  {/* <HotelIcon className="text-gray-600" /> */}
                  <img src={Bed} alt="bed" />
                  <span>
                    {data?.propertyDetails?.bedroomsTotal || "-"} Beds
                  </span>
                </div>
                <div className="flex items-center space-x-1">
                  {/* <BathtubOutlinedIcon className="text-gray-600" /> */}
                  <img src={Bath} alt="bed" />
                  <span>
                    {data?.propertyDetails?.bathroomsTotal || "-"} Baths
                  </span>
                </div>
                <div className="flex items-center space-x-1">
                  {/* <CottageOutlinedIcon className="text-gray-600" /> */}
                  <img src={Sqft} alt="bed" />
                  <span>
                    {squareFeetDetail?.label === "Square Feet"
                      ? isNaN(data?.cascadeInfo?.sqFt) &&
                        !squareFeetDetail?.value
                        ? "-" // If sqFt is NaN and there's no value in propertyDetails
                        : data?.cascadeInfo?.sqFt || // Show cascadeInfo.sqFt if valid
                        squareFeetDetail?.value.replace(/[^0-9]/g, "") // Otherwise, show the cleaned value from propertyDetails
                      : "-"}
                    Sq. Ft.
                  </span>
                </div>
              </div>
            }

            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
              gap={0.5}
              sx={{ mt: { sm: 1 } }}
            >
              <IconButton
                onClick={() => handleAddFavoriteProperties(param.propertyId)}
                style={{
                  cursor: "pointer",
                }}
                aria-label={
                  !selectedIndex.includes(param.propertyId)
                    ? "Add to favorites"
                    : "Remove from favorites"
                }
              >
                {/* Conditional rendering of the icon */}
                {!selectedIndex.includes(param.propertyId) ? (
                  <svg
                    stroke="#FF5C39"
                    fill="#FF5C39"
                    stroke-width="0"
                    viewBox="0 0 1024 1024"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z"></path>
                  </svg>
                ) : (
                  <svg
                    stroke="#FF5C39"
                    fill="#FF5C39"
                    stroke-width="0"
                    viewBox="0 0 1024 1024"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z"></path>
                  </svg>
                )}
              </IconButton>
              <Typography
                sx={{
                  color: "#FF5C39",
                  fontSize: "16px",
                  fontWeight: 500,
                  lineHeight: "24px",
                  mb: 0.2,
                }}
              >
                Save
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
      <StepperComponent />
      <Box sx={{ maxWidth: "99%", marginTop: 1 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 2,
          }}
        >
          {/* Left Section */}
          <Box sx={{ flex: 1 }}>
            {photos && photos.length <= 0 ? (
              <Paper
                elevation={1}
                sx={{ position: "relative", marginBottom: 2 }}
              >
                <div className=" w-full h-[60vh] object-fill items-center justify-center bg-[#EBEBEB] flex">
                  {loading ? (
                    <Loading />
                  ) : (
                    <span className="text-base text-[#3B3B3B] font-normal">
                      Photos currently not available
                    </span>
                  )}
                </div>
              </Paper>
            ) : (
              <Paper
                elevation={1}
                sx={{ position: "relative", marginBottom: 2 }}
              >
                <div
                  className={`flex transition ease-in-out duration-500 transform translate-x-[${currentIndex * 100
                    }%] w-[${photos.length * 100}%] relative`}
                  style={{
                    position: "relative", // Ensure the container has a stable height
                    height: "65vh", // Default height, can be adjusted based on media queries
                    maxHeight: "80vh", // Optionally set a max height for larger screens
                  }}
                >
                  {loading ? (
                    <div className="absolute inset-0 flex justify-center items-center">
                      <Loading />
                    </div>
                  ) : (
                    <img
                      src={photos[currentIndex]}
                      alt={`Property${currentIndex + 1}`}
                      onLoad={handleImageLoad}
                      onError={handleImageError}
                      className="w-full h-auto object-cover"
                    />
                  )}
                </div>

                {photos.length > 1 && (
                  <>
                    <div className="absolute bottom-3 right-4 flex items-center bg-black bg-opacity-50 text-white text-lg px-2 py-1 rounded">
                      <GoImage size={24} className="mr-2" />
                      {`${currentIndex + 1}/${photos.length}`}
                    </div>

                    <IconButton
                      sx={{
                        position: "absolute",
                        left: 8,
                        top: "50%",
                        transform: "translateY(-50%)",
                        bgcolor: "white",
                      }}
                      onClick={handlePrevPhoto}
                    >
                      <BsChevronLeft size={20} />
                    </IconButton>

                    <IconButton
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: "50%",
                        transform: "translateY(-50%)",
                        bgcolor: "white",
                      }}
                      onClick={handleNextPhoto}
                    >
                      <BsChevronRight size={20} />
                    </IconButton>
                  </>
                )}
              </Paper>
            )}

            <Paper
              elevation={1}
              sx={{
                position: "relative",
                padding: 2,
                paddingBottom: 6,
                overflow: "auto",
                marginTop: 5,
                minHeight: "370px",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  borderBottom: "1px solid #e0e0e0", // Same border as h5
                  paddingBottom: 1, // Padding at the bottom, same as h5
                  fontSize: "20px", // Default font size for h5 (equivalent to 20px)
                  lineHeight: 1.6, // Adjusting the line height to match the h5 variant's default
                }}
              >
                Property Details
              </Typography>
              <Typography
                variant="subtitle1"
                gutterBottom
                sx={{ fontWeight: 500, fontSize: "18px" }}
              >
                Property Description
              </Typography>

              {data?.cascadeInfo?.marketingDescription ? (
                <Typography
                  className={`read-more-text ${isExpandedOtherInfo ? "expanded" : ""
                    } transition-all duration-300 ease-in-out`}
                >
                  {isExpandedOtherInfo
                    ? data?.cascadeInfo?.marketingDescription
                    : handleTranctedText(
                      data?.cascadeInfo?.marketingDescription,
                      300
                    )}

                  {/* Only show the Read More / Less button inside the same Typography if the description is longer than 300 */}
                  {data?.cascadeInfo?.marketingDescription.length > 300 && (
                    <span
                      className="read-more-button cursor-pointer"
                      onClick={() =>
                        setIsExpandedOtherInfo(!isExpandedOtherInfo)
                      }
                    >
                      {isExpandedOtherInfo ? " Read Less" : " Read More"}
                    </span>
                  )}
                </Typography>
              ) : (
                <Typography className="text-[#9FA4AB]">
                  No Description Available
                </Typography>
              )}
              <Typography
                variant="subtitle1"
                gutterBottom
                sx={{
                  fontWeight: "medium",
                  marginTop: "10px",
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                Details
              </Typography>

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  "& > *": {
                    borderBottom: "1px solid #e0e0e0",
                    paddingBottom: "8px",
                    padding: 1,
                  },
                }}
              >
                {data?.propertyDetails?.basicDetails?.length > 0 ? (
                  data?.propertyDetails?.basicDetails.map((details, index) => {
                    if (index > 5) {
                      return (
                        <React.Fragment
                          key={index}
                          className={`ease-in-out duration-500`}
                        >
                          <Typography
                            style={{
                              borderBottom: viewMore
                                ? "1px solid #e0e0e0"
                                : "none",
                              paddingBottom: viewMore ? "8px" : "0px",
                              padding: viewMore ? 8 : 0,
                              opacity: viewMore ? 1 : 0,
                              maxHeight: viewMore ? "1000px" : "0", // Ensure smooth collapse
                              overflow: "hidden", // Hide content when collapsed
                              transition: "0.5s ease-in-out", // Transition for opacity and max-height
                            }}
                            variant="body2"
                            color="text.secondary"
                            className={`${viewMore ? "opacity-100" : "opacity-0"
                              }`}
                          >
                            {details.label} :
                          </Typography>
                          <Typography
                            style={{
                              borderBottom: viewMore
                                ? "1px solid #e0e0e0"
                                : "none",
                              paddingBottom: viewMore ? "8px" : "0px",
                              padding: viewMore ? 8 : 0,
                              opacity: viewMore ? 1 : 0,
                              maxHeight: viewMore ? "1000px" : "0", // Ensure smooth collapse
                              overflow: "hidden", // Hide content when collapsed
                              transition:
                                "opacity 0.5s ease-in-out, max-height 0.5s ease-in-out", // Transition for opacity and max-height
                            }}
                            variant="body2"
                            fontWeight={500}
                          >
                            {details.value}
                          </Typography>
                        </React.Fragment>
                      );
                    }
                    return (
                      <React.Fragment key={index}>
                        <Typography variant="body2" color="text.secondary">
                          {details.label} :
                        </Typography>
                        <Typography variant="body2" fontWeight={500}>
                          {details.value}
                        </Typography>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <>
                    <Typography variant="body2" color="text.secondary">
                      Property Type :
                    </Typography>
                    <Typography variant="body2">{" - "}</Typography>

                    <Typography variant="body2" color="text.secondary">
                      Occupancy Status :
                    </Typography>
                    <Typography variant="body2">{" - "}</Typography>

                    <Typography variant="body2" color="text.secondary">
                      Bedrooms :
                    </Typography>
                    <Typography variant="body2">{" - "}</Typography>

                    <Typography variant="body2" color="text.secondary">
                      Bathrooms :
                    </Typography>
                    <Typography variant="body2">{" - "}</Typography>

                    <Typography variant="body2" color="text.secondary">
                      County :
                    </Typography>
                    <Typography variant="body2">{" - "}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      Title :
                    </Typography>
                    <Typography variant="body2">{" - "}</Typography>

                    <Typography
                      style={{
                        borderBottom: viewMore ? "1px solid #e0e0e0" : "none",
                        paddingBottom: viewMore ? "8px" : "0px",
                        opacity: viewMore ? 1 : 0,
                        maxHeight: viewMore ? "1000px" : "0", // Ensure smooth collapse
                        overflow: "hidden", // Hide content when collapsed
                        transition: "0.5s ease-in-out", // Transition for opacity and max-height
                      }}
                      variant="body2"
                      color="text.secondary"
                      className={`${viewMore ? "opacity-100" : "opacity-0"}`}
                    >
                      Property # :
                    </Typography>
                    <Typography
                      style={{
                        borderBottom: viewMore ? "1px solid #e0e0e0" : "none",
                        paddingBottom: viewMore ? "8px" : "0px",
                        opacity: viewMore ? 1 : 0,
                        maxHeight: viewMore ? "1000px" : "0", // Ensure smooth collapse
                        overflow: "hidden", // Hide content when collapsed
                        transition:
                          "opacity 0.5s ease-in-out, max-height 0.5s ease-in-out", // Transition for opacity and max-height
                      }}
                      variant="body2"
                      fontWeight={500}
                    >
                      {" - "}
                    </Typography>
                    <Typography
                      style={{
                        borderBottom: viewMore ? "1px solid #e0e0e0" : "none",
                        paddingBottom: viewMore ? "8px" : "0px",
                        opacity: viewMore ? 1 : 0,
                        maxHeight: viewMore ? "1000px" : "0", // Ensure smooth collapse
                        overflow: "hidden", // Hide content when collapsed
                        transition: "0.5s ease-in-out", // Transition for opacity and max-height
                      }}
                      variant="body2"
                      color="text.secondary"
                      className={`${viewMore ? "opacity-100" : "opacity-0"}`}
                    >
                      Lot Size :
                    </Typography>
                    <Typography
                      style={{
                        borderBottom: viewMore ? "1px solid #e0e0e0" : "none",
                        paddingBottom: viewMore ? "8px" : "0px",
                        opacity: viewMore ? 1 : 0,
                        maxHeight: viewMore ? "1000px" : "0", // Ensure smooth collapse
                        overflow: "hidden", // Hide content when collapsed
                        transition:
                          "opacity 0.5s ease-in-out, max-height 0.5s ease-in-out", // Transition for opacity and max-height
                      }}
                      variant="body2"
                      fontWeight={500}
                    >
                      {" - "}
                    </Typography>
                    <Typography
                      style={{
                        borderBottom: viewMore ? "1px solid #e0e0e0" : "none",
                        paddingBottom: viewMore ? "8px" : "0px",
                        opacity: viewMore ? 1 : 0,
                        maxHeight: viewMore ? "1000px" : "0", // Ensure smooth collapse
                        overflow: "hidden", // Hide content when collapsed
                        transition: "0.5s ease-in-out", // Transition for opacity and max-height
                      }}
                      variant="body2"
                      color="text.secondary"
                      className={`${viewMore ? "opacity-100" : "opacity-0"}`}
                    >
                      Lot/ :
                    </Typography>
                    <Typography
                      style={{
                        borderBottom: viewMore ? "1px solid #e0e0e0" : "none",
                        paddingBottom: viewMore ? "8px" : "0px",
                        opacity: viewMore ? 1 : 0,
                        maxHeight: viewMore ? "1000px" : "0", // Ensure smooth collapse
                        overflow: "hidden", // Hide content when collapsed
                        transition:
                          "opacity 0.5s ease-in-out, max-height 0.5s ease-in-out", // Transition for opacity and max-height
                      }}
                      variant="body2"
                      fontWeight={500}
                    >
                      {" - "}
                    </Typography>
                  </>
                )}
              </Box>
              {
                <div
                  className={`transition-all ease-in-out duration-500`}
                  style={{
                    maxHeight: viewMore ? "1000px" : "0", // Control height for smooth expansion
                    overflow: "hidden", // Hide overflow when collapsed
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    sx={{
                      fontWeight: "medium",
                      mt: 4,
                      borderBottom: "1px solid #e0e0e0",
                    }}
                  >
                    Exterior / Lot Features
                  </Typography>

                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr", // Ensure each item is in one row
                      // gap: 2, // Space between rows
                      "& > *": {
                        borderBottom: "1px solid #e0e0e0", // Border between rows
                        padding: 1,
                      },
                    }}
                  >
                    {data?.propertyDetails?.exteriorLotFeatures?.length > 0 ? (
                      data?.propertyDetails.exteriorLotFeatures.map(
                        (details, index) => (
                          <React.Fragment key={index}>
                            <Box sx={{ display: "flex" }}>
                              <Typography
                                variant="body2"
                                minWidth={"120px"}
                                color="text.secondary"
                              >
                                {details.label}:
                              </Typography>
                              <Typography variant="body2">
                                {details.value || " - "}
                              </Typography>
                            </Box>
                          </React.Fragment>
                        )
                      )
                    ) : (
                      <>
                        <Box sx={{ display: "flex" }}>
                          <Typography
                            variant="body2"
                            minWidth={"120px"}
                            color="text.secondary"
                          >
                            Parking
                          </Typography>
                          <Typography variant="body2">{" - "}</Typography>
                        </Box>
                        <Box sx={{ display: "flex" }}>
                          <Typography
                            variant="body2"
                            minWidth={"120px"}
                            color="text.secondary"
                          >
                            Pool:
                          </Typography>
                          <Typography variant="body2">{" - "}</Typography>
                        </Box>
                      </>
                    )}
                  </Box>
                </div>
              }

              {/* In case Of product desc is not available view more button is not visible and  */}
              {data?.cascadeInfo?.marketingDescription && (
                <Typography
                  sx={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",

                    // gap: , // Space between text and icon
                  }}
                  className="duration-500"
                  position={"absolute"}
                  left={"40%"}
                  bottom={10}
                  fontWeight={500}
                  textAlign={"center"}
                  color="#FF5C39"
                  onClick={() => setViewMore((prev) => !prev)}
                >
                  {viewMore ? `View Less` : "View More"}
                  {!viewMore ? (
                    <KeyboardArrowDownIcon />
                  ) : (
                    <KeyboardArrowUpIcon />
                  )}
                </Typography>
              )}
            </Paper>
          </Box>

          {/* Right Section */}
          <Box sx={{ flex: 1 }}>
            <Paper elevation={1} sx={{ padding: 2, marginBottom: 2 }}>
              <Typography
                gutterBottom
                sx={{ fontWeight: 600, fontSize: "22px", color: "#3B3B3B" }}
                className="justify-center flex items-center"
                role="heading"
              >
                Live Event {data?.isRemoteBiddingEligible && "- Remote Bid Enabled"}
              </Typography>
              <Divider sx={{ mb: 1 }} />
              <Box>
                {data?.auctionStatusName === "Closed" && data?.auctionRedoStatus === 0 ? (
                  <Box>
                    {data?.salePrice && data?.soldStatus ? (
                      <>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: "18px",
                              color: "#3B3B3B",
                              fontWeight: 600,
                              marginLeft: "20px",
                            }}
                          >
                            Sale Price
                          </Typography>
                          <Box
                            sx={{
                              marginRight: "100px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 2,
                            }}
                          >
                            <Typography
                              fontWeight={500}
                              className=" text-[18px] leading-[27px] text-[#3B3B3B]"
                            >
                              $
                              {data?.salePrice === ""
                                ? 0
                                : formatToDollar(data?.salePrice, 0)}
                            </Typography>
                            <Box
                              sx={{
                                border:
                                  investorIdCheck.includes(data.winnerInvestorId)
                                    ? "1px solid #28A745"
                                    : "1px solid grey",
                                color:
                                  investorIdCheck.includes(data.winnerInvestorId)
                                    ? "#28A745"
                                    : "initial",
                                p: 1,
                                fontSize: "16px",
                                width: "auto",
                              }}
                            >
                              {investorIdCheck.includes(data.winnerInvestorId)
                                ? "You won"
                                : data?.soldStatus}
                            </Box>
                          </Box>
                        </Box>
                        {(data.resciptName && investorIdCheck.includes(data.winnerInvestorId)) && (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                              my: 1,
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{
                                fontSize: "18px",
                                color: "#3B3B3B",
                                fontWeight: 600,
                                marginLeft: "20px",
                              }}
                            >
                              Receipt of Sale
                            </Typography>
                            <Box
                              onClick={() =>
                                openPDFModal(
                                  data?.reciptOfSale,
                                  data.resciptName
                                )
                              }
                              // mb={3}
                              color={textColor.primaryColor}
                              display={"flex"}
                              sx={{ cursor: "pointer" }}
                              alignItems={"center"}
                            >
                              <span style={{ textDecoration: "underline" }}>
                                {data.resciptName}
                              </span>
                            </Box>
                          </Box>
                        )}
                      </>) :
                      <></>
                    }
                  </Box>
                ) : (
                  <Box className="grid gap-y-2">
                    {/* First Row: Reserve Price */}
                    <div className="grid grid-cols-12 items-center">
                      <Typography
                        className="col-span-5 md:col-span-3"
                        variant="body1"
                        sx={{
                          fontSize: "18px",
                          color: "#3B3B3B",
                          fontWeight: 500,
                        }}
                      >
                        Est. Opening Bid
                      </Typography>
                      <div className="flex  items-center gap-3">
                        <span className="font-medium text-[18px] text-[#3B3B3B] ">
                          $
                          {data?.propertyDetails?.startingBid === null || data?.propertyDetails?.startingBid === 0 || data?.propertyDetails?.startingBid === "0" || data?.propertyDetails?.startingBid === 0.00
                            ? (data?.cascadeInfo?.reserveValue > 0 ? formatToDollar(data?.cascadeInfo?.reserveValue, 2) : 0)

                            : formatToDollar(
                              data?.propertyDetails?.startingBid, 2
                            )}
                        </span>

                        {/* {data?.cascadeInfo?.reserveValue == 0 && (
                          <IconButton onClick={handleInfoBoxOpen}>
                            <BsInfoCircle
                              style={{
                                color: "#FF5C39",
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                              }}
                            />
                          </IconButton>
                        )} */}
                      </div>
                    </div>

                    {data?.cascadeInfo?.reserveValue != estOpeningBid &&
                      data?.cascadeInfo?.reserveValue > 0 && estOpeningBid > 0 && (
                        <div className="grid grid-cols-12 ">
                          <Typography
                            className="col-span-5 md:col-span-3"
                            variant="body1"
                            sx={{
                              fontSize: "18px",
                              color: "#3B3B3B",
                              fontWeight: 500,
                            }}
                          >
                            Reserve Price
                          </Typography>

                          <span className="font-medium text-[18px] col-span-1 text-[#3B3B3B] ">
                            $
                            {isNaN(data?.cascadeInfo?.reserveValue) && data?.cascadeInfo?.reserveValue === null
                              ? 0
                              : formatToDollar(data?.cascadeInfo?.reserveValue, 2)}
                          </span>
                        </div>
                      )}
                    {/* Opening Date and Time below Reserve Price */}
                  </Box>
                )}
              </Box>
              {data?.auctionStatusName === "Closed" ? (
                <></>
              ) : (
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "16px",
                    color: "#3B3B3B",
                    fontWeight: 500,
                    marginTop: 1, // Add some space above the date/time
                  }}
                >
                  {openingDate}, {openingTime}
                </Typography>
              )}
            </Paper>
            {data?.propertyDetails?.legalBanners?.map((banner) => (
              <Paper
                elevation={1}
                sx={{ padding: 2, marginBottom: 2, bgcolor: "#fffff" }}
              >
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ fontWeight: 500, fontSize: "18px", color: "#FF5C39" }}
                >
                  {banner.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 400, fontSize: "13px", color: "#3B3B3B" }}
                >
                  {banner.title === "PAYMENT INFORMATION:" ? (
                    <Typography
                      fontSize={13}
                      className={`read-more-text ${isExpanded ? "expanded" : ""
                        } transition-all duration-500 ease-in-out`}
                    >
                      {isExpanded
                        ? parse(banner.content)
                        : parse(handleTranctedText(banner.content, 300))}

                      {/* Only show the Read More / Less button inside the same Typography if the description is longer than 300 */}
                      {banner.content.length > 280 && (
                        <span
                          className="read-more-button cursor-pointer"
                          onClick={() => setIsExpanded(!isExpanded)}
                        >
                          {isExpanded ? " Read Less" : " Read More"}
                        </span>
                      )}
                    </Typography>
                  ) : (
                    parse(banner.content)
                  )}
                  {/* {parse(banner.content)} */}
                </Typography>
              </Paper>
            ))}
            {console.log(data)}
            <Paper elevation={1} sx={{ padding: 2 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  gutterBottom
                  sx={{ fontWeight: 600, fontSize: "18px", color: "#3B3B3B" }}
                >
                  Event Details
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 400, fontSize: "14px", color: "#3B3B3B" }}
                >
                  {
                    // Show Live Icon only when countdown is finish and live 
                    data?.isRemoteBiddingEligible &&
                      ((data?.auctionStatusName === "Live" || data?.auctionRedoStatus !== 0 || (["Upcoming", "Paused", "PreAuctionClosed", "Postponed"]?.includes(data?.auctionStatusName) && countdown == 0))) ? (
                      <div className="w-5/5">
                        <LiveIcon />
                      </div>
                    ) : (data?.isRemoteBiddingEligible && (data?.auctionStatusName === "Upcoming" || data?.auctionStatusName === "Postponed" || data?.auctionStatusName === "Paused" || data?.auctionStatusName === "PreAuctionClosed") && countdown > 0) ? (
                      <div className="flex gap-2 items-end">
                        Auction Starts in
                        <div className="font-[500] w-[185px] text-[18px]">
                          {formatCountdown(countdown)}
                        </div>
                      </div>
                    ) : null
                  }


                  {/* {(data?.auctionStatusName === "Live" ||
                    (data?.auctionStatusName === "Upcoming" && countdown <= 1000 * 60 * 60) || (data?.auctionStatusName === "Paused" && countdown <= 1000 * 60 * 60)) &&
                    data?.auctionStatusName != "PreAuctionClosed" ? (
                    <div className="w-5/5">
                      <LiveIcon />
                    </div>
                  ) : (
                    (data?.auctionStatusName === "Upcoming" ||
                      data?.auctionStatusName === "Paused") ? (
                      <div className="flex gap-2 items-end">
                        Auction Starts in
                        <div className="font-[500] w-[185px] text-[18px]">
                          {formatCountdown(countdown)}
                        </div>
                      </div>
                    )
                  ):null} */}
                </Typography>
              </Box>
              <hr />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 2,
                }}
              >
                <div className="flex items-center justify-center gap-x-4">
                  <CalendarMonthOutlinedIcon
                    color="#3B3B3B"
                    sx={{ fontSize: 34 }}
                  />
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 500, fontSize: "18px", color: "#3B3B3B" }}
                  >
                    {openingDate} {openingTime}
                  </Typography>

                  {/* <Button
                    color="primary"
                    sx={{
                      marginBottom: 0,
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <CalendarMonthOutlinedIcon
                      color="primary"
                      sx={{ fontSize: 20, mr: 0.5 }}
                    />
                    <p className="text-center font-medium text-sm">
                      Add to Calendar
                    </p>
                  </Button> */}
                </div>
              </Box>
              <Typography
                variant="body2"
                sx={{
                  alignItems: "center",
                  display: "flex",
                  paddingLeft: 6,
                  fontWeight: 400,
                  fontSize: "16px",
                  marginTop: 1,
                  color: "#3B3B3B",
                }}
              >
                {data?.propertyDetails?.liveAuctionLocationName}
                <br />
                {data?.propertyDetails?.liveAuctionLocation1}{" "}
                {data?.propertyDetails?.liveAuctionLocation2}
                <br />
                {data?.propertyDetails?.liveAuctionLocationDescription}
              </Typography>

              <div className="flex justify-center items-center mt-3 mb-1">
                {(data?.auctionStatusName !== "Closed" || data?.auctionRedoStatus !== 0) && data?.isRemoteBiddingEligible && (
                  <Button
                    disabled={!isPlaceBidButtonEnabled(data?.auctionStatusName)}
                    sx={{
                      backgroundColor: "#FF5C39",
                      fontWeight: 500,
                      fontSize: "16px",
                      color: "white",
                      textTransform: "none",
                    }}
                    variant="contained"
                    onClick={handlePlaceBid}
                  >
                    Place Bid
                  </Button>
                )}
                <RightSidebar
                  isOpen={isSidebarOpen}
                  toggleSidebar={toggleSidebar}
                  auctionId={auctionId}
                  activeStep={activeStep}
                  setActiveStep={setActiveStep}
                  completed={completed}
                  setCompleted={setCompleted}
                  openingBid={data?.cascadeInfo?.openingBid}
                  reservePrice={data?.cascadeInfo?.reserveValue}
                />
              </div>
              <div className="flex justify-center items-center">
                {(data?.auctionStatusName == "PreAuctionClosed" &&
                  countdown > 0 && data?.isRemoteBiddingEligible) &&
                  (
                    <span className="text-center font-medium text-sm">
                      *Proxy Bidding window closes{" "}
                      {data?.preWindowClosingTimeFrame >= 60
                        ? // Convert to hours if ≥60 minutes
                        `${Math.floor(data.preWindowClosingTimeFrame / 60)} hour${Math.floor(data.preWindowClosingTimeFrame / 60) !== 1 ? "s" : ""
                        }`
                        : // Keep in minutes otherwise
                        `${data.preWindowClosingTimeFrame} minute${data.preWindowClosingTimeFrame !== 1 ? "s" : ""
                        }`}{" "}
                      before auction starts.
                    </span>
                  )}
              </div>

              <Typography
                variant="caption"
                align="center"
                display="block"
                sx={{ marginTop: 1 }}
              >
                {statusmessage}
              </Typography>
            </Paper>
            <Paper
              elevation={1}
              sx={{
                padding: 2,
                marginTop: 2,
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "medium",
                    marginBottom: 1,
                    borderBottom: "1px solid #e0e0e0",
                    paddingBottom: 1,
                  }}
                >
                  Trustee/ Attorney Information
                </Typography>

                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  {/* Name */}
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "140px 1fr",
                      alignItems: "center",
                      borderBottom: "1px solid #e0e0e0",
                      p: 1,
                    }}
                  >
                    <Typography variant="body2" color="text.secondary">
                      Name :
                    </Typography>
                    <Typography variant="body2" style={{ fontWeight: 500 }}>
                      {/* <span style={{marginRight:"40px"}}>:</span>  */}
                      {data?.cascadeInfo?.fcattorney === ""
                        ? " - "
                        : data?.cascadeInfo?.fcattorney}
                    </Typography>
                  </Box>

                  {/* Address */}
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "140px 1fr",
                      alignItems: "center",
                      borderBottom: "1px solid #e0e0e0",
                      p: 1,
                    }}
                  >
                    <Typography variant="body2" color="text.secondary">
                      Address :
                    </Typography>
                    <Typography variant="body2" style={{ fontWeight: 500 }}>
                      {" "}
                      {/* <span style={{marginRight:"40px"}}></span> */}
                      {data?.cascadeInfo?.fcattorneyAddress === ""
                        ? " - "
                        : data?.cascadeInfo?.fcattorneyAddress}
                    </Typography>
                  </Box>

                  {/* Phone Number */}
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "140px 1fr",
                      alignItems: "center",
                      borderBottom: "1px solid #e0e0e0",
                      p: 1, // Uniform padding for all items
                    }}
                  >
                    <Typography variant="body2" color="text.secondary">
                      Phone Number :
                    </Typography>
                    <Typography variant="body2" style={{ fontWeight: 500 }}>
                      {/* <span style={{marginRight:"40px"}}>:</span> */}
                      {data?.cascadeInfo?.fcattorneyPhone === ""
                        ? " - "
                        : formatPhoneNumber(data?.cascadeInfo?.fcattorneyPhone)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Paper>
          </Box>
        </Box>

        <Grid container spacing={2} marginTop={2}>
          <Grid size={{ xs: 12, md: 8 }} className="">
            <Paper
              elevation={1}
              sx={{
                maxWidth: "3xl",
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: 1,
              }}
            >
              <Box component="div" sx={{ mb: 3, p: 2 }}>
                <Typography
                  role="heading"
                  gutterBottom
                  sx={{
                    fontWeight: 600,
                    mb: 2,
                    fontSize: "20px",
                    borderBottom: "1px solid #e0e0e0",
                  }}
                >
                  Auction Disclaimer
                </Typography>

                <Box component="ul" sx={{ listStyle: "none", pl: 0, m: 0 }}>
                  {data &&
                    data?.disclaimers?.length > 0 &&
                    data?.disclaimers?.map((text, index) => (
                      <Box
                        component="li"
                        key={index.id}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          mb: 0.9,
                          textAlign: "justify",
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{ color: "black", mr: 1, mt: "-3px" }}
                        >
                          •
                        </Typography>
                        <Typography variant="body2">
                          {text.disclaimersText}
                        </Typography>
                      </Box>
                    ))}
                </Box>
              </Box>
            </Paper>
          </Grid>

          <Grid size={{ xs: 12, md: 3 }}>
            <Paper elevation={1} sx={{ maxWidth: { md: "400px" }, p: 3 }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  mb: 2,
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                May We Assist You?
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Need help? Check out our
                <Link
                  href="https://solutionstar.zendesk.com/hc/en-us"
                  target="_blank"
                  sx={{ color: "#FF5C39", fontWeight: "bold", mx: 1 }}
                >
                  Help Center
                </Link>
                {" "}  for answers to common questions.
              </Typography>
              <Typography variant="body2">
                If you have questions specific to this property, either
                pre-auction or during the live auction event, please contact{" "}
                <Link
                  href="tel:8007588052"
                  sx={{ fontWeight: "normal", color: "black" }}
                >
                  (800) 758-8052
                </Link>
                . For post-auction questions, please contact{" "}
                <Link
                  href="tel:8006832468"
                  sx={{ fontWeight: "normal", color: "black" }}
                >
                  (800) 683-2468
                </Link>
                .
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>
      {data?.cascadeInfo?.reserveValue <= 0 && (
        <Popover
          open={popover}
          anchorEl={anchorEl}
          onClose={handleInfoBoxClose}
          anchorOrigin={{
            vertical: "top",
            // horizontal: "left",
          }}
          transformOrigin={
            {
              // vertical: "center",
              // horizontal: "left"
            }
          }
          slotProps={{
            paper: {
              sx: {
                overflow: "visible",
                borderRadius: "8px",
                borderTopLeftRadius: 3,
                paddingX: 2,
                paddingY: 1,
                maxWidth: 320,
                ml: 4,
                mt: -1,
                boxShadow: "3px 3px 5px 2px rgba(0,0,0,0.1)", // Add shadow for depth
                "&:after,&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 8, // Move above the popover
                  left: -9, // Align to the left corner with a small margin
                  width: 18,
                  height: 18,
                  backgroundColor: "white", // Match the popover's background
                  transform: "rotate(45deg)", // Rotate to form the arrow
                  boxShadow: "-3px 3px 5px -2px rgba(0,0,0,0.1)", // Arrow shadow
                },
              },
            },
          }}
        >
          {/* Arrow Style */}

          {/* Popover Content */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              variant="subtitle1"
              fontWeight="500"
              fontSize={16}
              sx={{ color: "#3B3B3B" }}
            >
              Note
            </Typography>
            <IconButton
              size="small"
              onClick={handleInfoBoxClose}
              sx={{
                padding: 0,
                color: "#3B3B3B",
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <hr />
          <Typography
            variant="body2"
            fontWeight={"400"}
            fontSize={12}
            sx={{
              color: "#3B3B3B",
              marginTop: 1,
              textAlign: "left",
              lineHeight: 1.5,
            }}
          >
            The Reserve Price is currently unavailable. Once it becomes
            available, you will be notified if your proxy bid is lower than the
            Reserve Price. Proxy bids lower than the Reserve Price will be
            automatically discarded.
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              sx={{
                backgroundColor: "#FF5C39",
                fontWeight: 500,
                fontSize: "14px",
                color: "white",
                textTransform: "none",
                margin: "auto",
                marginTop: 2,
              }}
              variant="contained"
              onClick={handleInfoBoxClose}
            >
              Got it
            </Button>
          </Box>
        </Popover>
      )}
    </ThemeProvider>
  );
}
